module.exports = __webpack_public_path__ + "img/soccerboard88.f073cd93.jpg";